import React, {Fragment, useState, useEffect, memo} from 'react';
import IndexRow from "./IndexRow";
import {isUniformObjectArray} from "../utils/json";

const List = memo(({value, collapseAll}) => {
    const [topKeyClicks, setTopKeyClicks] = useState({})
    const [keys, setKeys] = useState([])
    const [isSame, setIsSame] = useState(true)

    const onClickTopKey = (keyVal) =>{
        setTopKeyClicks(prev => ({...prev, [keyVal]: !prev[keyVal]}))
    }

    useEffect(()=>{
        const same = isUniformObjectArray(value)
        setIsSame(same)
        if (same){
            const tempKeys = Object.keys(value[0])
            setKeys(tempKeys)
            setTopKeyClicks(Object.fromEntries(tempKeys.map(k => [k, false])))
        }
    }, [value, collapseAll])


    return (
        <Fragment>
        {!value.length?'[]':
            isSame?<table>
                <tbody>
                <tr>
                    <th key='index' className={'text-muted text-small'}> Index</th>
                    {keys.map(keyVal => <th key={keyVal}>
                        <i className={topKeyClicks[keyVal]?'mdi mdi-arrow-down-drop-circle-outline':"mdi mdi-arrow-up-drop-circle-outline"}
                           onClick={() => onClickTopKey(keyVal)}> </i>
                        {keyVal}
                    </th>)}
                </tr>
                {value.map((item, index)=><tr key={index}><IndexRow keys={keys}
                                                                    item={item}
                                                                    index={index}
                                                                    topKeyClicks={topKeyClicks}
                                                                    collapseAll={collapseAll}
                /></tr>)}
                </tbody>
        </table>:<table className={'ListTable'}>
            <tbody>
            <tr>
                <th className={'text-muted text-small'} style={{padding:'5px'}}> Index</th>
                <th> </th>
            </tr>
                {value.map((item, index)=><tr key={index}>
                    <IndexRow item={item} index={index} collapseAll={collapseAll}/>
                </tr>)}
            </tbody>
        </table>
        }
        </Fragment>
    )
})

export default List;
